export const formatHeader = (key: string) => {
  return (
    key
      // replace underscores with spaces
      .replace(/_/g, ' ')
      // insert space before capital letters (for camelCase like eventContactEmail)
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      // trim in case of double spaces
      .trim()
      // capitalize first letter of each word
      .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1))
  );
};
